import { render, staticRenderFns } from "./NotEligible.vue?vue&type=template&id=5662bed4&"
import script from "./NotEligible.vue?vue&type=script&lang=js&"
export * from "./NotEligible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports